import { useState } from "react";

const useAdminPaymentHistory = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return {
        isModalOpen,
        setIsModalOpen
    }
}

export default useAdminPaymentHistory;